module.exports = __webpack_public_path__ + "media/images/voice11-2-4f0d659cf295d9766e0ad0b3ff6a5222.jpg";